export default __webpack_public_path__ + "static/media/benefit_5.8e2e54bb.png";